import React from 'react'
import { ProductVariant } from '../../utils/interfaces/product'

interface deliveryDateProps {
  currentVariant: ProductVariant
}

const getEstimatedDeliveryDate: React.FC<deliveryDateProps> = ({ currentVariant }) => {
  const localizationCookie = currentVariant.currentCountry;
  let cutoffHour = 11
  if (localizationCookie === 'United States') {
    cutoffHour = 11
  } else {
    cutoffHour = 10
  }

  const now = new Date();
  const currentHour = now.getHours();
  let daysToAdd = currentHour < cutoffHour ? 3 : 4;

  const deliveryDate = new Date(now);

  while (daysToAdd > 0) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
    const dayOfWeek = deliveryDate.getDay();
    //Exclude Weekends from being counted
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      daysToAdd--;
    }
  }
  // Check if deliveryDate is Sunday (0), if so add one more day
  if (deliveryDate.getDay() === 0) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  }
  const latestPossibleDate = new Date(deliveryDate);
  if(localizationCookie === 'United States') {
    latestPossibleDate.setDate(latestPossibleDate.getDate() + (deliveryDate.getDay() >= 5 ? 4 : 3));
  }else {
    latestPossibleDate.setDate(latestPossibleDate.getDate() + (deliveryDate.getDay() >= 5 ? 8 : 7));
  }
  // Check if latestPossibleDate is Sunday (0), if so add one more day
  if (latestPossibleDate.getDay() === 0) {
    latestPossibleDate.setDate(latestPossibleDate.getDate() + 1);
  }
  const formattedDeliveryDate = `Estimated Delivery Date ${formatDate(deliveryDate)} to ${formatDate(latestPossibleDate)}`;
  const comingSoonProduct = currentVariant?.metafields?.badges.find((badge)=> badge.name.includes('Coming'));

  return (
    <>
      {currentVariant.availableForSale &&
        !comingSoonProduct &&
        (localizationCookie === 'United States' || localizationCookie === 'Canada') && (
        <div className="flex body-xxs mt-1.5">{formattedDeliveryDate}</div>
      )
      }
    </>
  )
}

function formatDate(date: Date) {
  const day = date.getDate();
  const month = date.toLocaleDateString('en-US', {month: 'long'});
  const nthNumber = (number: number) => {
    if (number > 3 && number < 21) return "th";
    switch (number % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }
  return `${month} ${day}${nthNumber(day)}`;
}

export default getEstimatedDeliveryDate;